import { UserHistoryAction } from "@shaarp/common";

export const translateUserHistoryAction = (
  action: UserHistoryAction,
  t: (key: string) => string,
): string => {
  switch (action) {
    case "REPORT_WRONG_EMPLOYEE_EMAIL":
      return t("user.history.reportWrongCompanyEmployeeEmail");
    case "REPORT_WRONG_EMPLOYEE_PHONE":
      return t("user.history.reportWrongCompanyEmployeePhone");
    case "REPORT_BAN_EMPLOYEE":
      return t("user.history.reportBanCompanyEmployee");
    case "FETCH_COMPANY":
      return t("user.history.fetchCompany");
    case "FETCH_COMPANY_EMPLOYEES":
      return t("user.history.fetchCompanyEmployees");
    case "FETCH_COMPANY_EMPLOYEE_EMAIL_ENRICHED":
      return t("user.history.fetchCompanyEmployeeEmailEnriched");
    case "FETCH_COMPANY_EMPLOYEE_PHONE_ENRICHED":
      return t("user.history.fetchCompanyEmployeePhoneEnriched");
    case "FETCH_COMPANY_EMAILS":
      return t("user.history.fetchCompanyEmails");
    case "FETCH_COMPANY_REVIEWS":
      return t("user.history.fetchCompanyReviews");
    case "FETCH_COMPANY_REVIEWS_RESUME":
      return t("user.history.fetchCompanyReviewsResume");
    case "FETCH_COMPANY_REVIEWS_RESUME_GENERATE":
      return t("user.history.fetchCompanyReviewsResumeGenerate");
    case "FETCH_COMPANY_ACTIVITIES":
      return t("user.history.fetchCompanyActivities");
    case "FETCH_COMPANY_ACTIVITIES_RESUME":
      return t("user.history.fetchCompanyActivitiesResume");
    case "FETCH_COMPANY_ACTIVITIES_RESUME_GENERATE":
      return t("user.history.fetchCompanyActivitiesResumeGenerate");
    case "FETCH_COMPANY_JOB_OFFERS":
      return t("user.history.fetchCompanyJobOffers");
    case "FETCH_COMPANY_JOB_OFFERS_RESUME":
      return t("user.history.fetchCompanyJobOffersResume");
    case "FETCH_COMPANY_SIMILARS":
      return t("user.history.fetchCompanySimilars");
    case "UPDATE_COMPANY_SOURCES":
      return t("user.history.updateCompanySources");
    case "SET_COMPANY_SOURCES_VERIFIED":
      return t("user.history.setCompanySourcesVerified");
    case "PUT_COMPANY_ASSIGNATION":
      return t("user.history.putCompanyAssignation");
    case "SEARCH_COMPANIES":
      return t("user.history.searchCompanies");
    case "SEARCH_PEOPLE":
      return t("user.history.searchPeople");
    case "LOOKUP_COMPANY_IDENTIFIER":
      return t("user.history.lookupCompanyIdentifier");
    case "SAVE_COMPANY_FROM_TAG":
      return t("user.history.saveCompanyFromTag");
    case "PREVIEW_COMPANY":
      return t("user.history.previewCompany");
    case "EXPORT_COMPANIES":
      return t("user.history.exportCompanies");
    case "UPDATE_TEAM_INSTRUCTION":
      return t("user.history.updateTeamInstruction");
    case "CREATE_PROMPT":
      return t("user.history.createPrompt");
    case "DELETE_PROMPT":
      return t("user.history.deletePrompt");
    case "SEND_TEAM_INVITATION":
      return t("user.history.sendTeamInvitation");
    case "DELETE_TEAM_USER":
      return t("user.history.deleteTeamUser");
    case "CANCEL_TEAM_INVITATION":
      return t("user.history.cancelTeamInvitation");
    case "UPDATE_TEAM_USER":
      return t("user.history.updateTeamUser");
    case "CREATE_TEAM":
      return t("user.history.createTeam");
    case "UPDATE_TEAM_INFORMATIONS":
      return t("user.history.updateTeamInformations");
    case "UPDATE_TEAM_COMPANY":
      return t("user.history.updateTeamCompany");
    case "UPDATE_PROMPT":
      return t("user.history.updatePrompt");
    case "LISTING_CREATE":
      return t("user.history.listingCreate");
    case "LISTING_UPDATE":
      return t("user.history.listingUpdate");
    case "LISTING_DELETE":
      return t("user.history.listingDelete");
    case "LISTING_ADD_COMPANIES":
      return t("user.history.listingAddCompanies");
    case "LISTING_DELETE_COMPANIES":
      return t("user.history.listingDeleteCompanies");
    case "CONVERSATION_CREATE":
      return t("user.history.conversationCreate");
    case "CONVERSATION_MESSAGE_ADD":
      return t("user.history.conversationMessageAdd");
    case "CONVERSATION_FILES_ADD":
      return t("user.history.conversationFilesAdd");
    case "CONVERSATION_DELETE":
      return t("user.history.conversationDelete");
    case "UPDATE_BILLING_EMAIL":
      return t("user.history.updateBillingEmail");
    case "UPDATE_USER_INSTRUCTION":
      return t("user.history.updateUserInstruction");
    case "UPDATE_USER_ADVISOR":
      return t("user.history.updateUserAdvisor");
    case "RESET_COMPANY_ENRICHMENT":
      return t("user.history.resetCompanyEnrichment");
    case "GENERATE_COMPANY_ADVICE":
      return t("user.history.generateCompanyAdvice");
    case "GENERATE_COMPANIES_ITINERARY":
      return t("user.history.generateCompaniesItinerary");
    case "LISTING_ADD_ASSIGNEES":
      return t("user.history.listingAddAssignees");
    case "LISTING_DELETE_ASSIGNEES":
      return t("user.history.listingDeleteAssignees");
    case "START_API_CREDITS_SUBSCRIPTION":
      return t("user.history.startApiCreditsSubscription");
    case "CANCEL_API_CREDITS_SUBSCRIPTION":
      return t("user.history.cancelApiCreditsSubscription");
    case "RESUME_API_CREDITS_SUBSCRIPTION":
      return t("user.history.resumeApiCreditsSubscription");
    case "CHANGE_API_CREDITS_SUBSCRIPTION":
      return t("user.history.changeApiCreditsSubscription");
    case "CREATE_TEAM_API_KEY":
      return t("user.history.createTeamApiKey");
    case "DELETE_TEAM_API_KEY":
      return t("user.history.deleteTeamApiKey");
    case "ADD_TEAM_KNOWLEDGE_FILES":
      return t("user.history.addTeamKnowledgeFiles");
    case "DELETE_TEAM_KNOWLEDGE_FILE":
      return t("user.history.deleteTeamKnowledgeFile");
    case "ADD_TEAM_KNOWLEDGE_WEBSITE":
      return t("user.history.addTeamKnowledgeWebsite");
    case "DELETE_TEAM_KNOWLEDGE_WEBSITE":
      return t("user.history.deleteTeamKnowledgeWebsite");
    case "REFRESH_TEAM_KNOWLEDGE_WEBSITE":
      return t("user.history.refreshTeamKnowledgeWebsite");
    case "ADMIN_INVITE_USER":
      return t("user.history.adminInviteUser");
    case "CREATE_INTEGRATION_CRM_COMPANY_LIST":
      return t("user.history.createIntegrationCrmCompanyList");
    case "CREATE_INTEGRATION_CRM_CONTACT_LIST":
      return t("user.history.createIntegrationCrmContactList");
    case "SYNC_COMPANIES_TO_PROVIDER_LIST":
      return t("user.history.syncCompaniesToProviderList");
    case "SYNC_EMPLOYEES_TO_PROVIDER_LIST":
      return t("user.history.syncEmployeesToProviderList");
    default:
      return action;
  }
};
